import PasswordInput from "./passwordInput";

export default PasswordInput;